import React from 'react'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { ReactComponent as ClockIcon } from 'assets/img/ic_clock.svg'
import ProfileHelper from 'helpers/profile'

function TimePickerInput(props) {
  let errorStatus = false
  let errorMessage = ''

  const {
    input: { name, onChange, value, ...restInput },
    meta: { submitError, touched, error },
    label,
    ampm,
    autoOk,
    required,
    disabled,
    ...rest
  } = props
  const locale = ProfileHelper.getCurrentLocale()

  if (touched && (error || submitError)) {
    errorStatus = true
    errorMessage = error || submitError
  }

  return (
    <div className="form-group">
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
        <KeyboardTimePicker
          {...rest}
          fullWidth
          ampm={ampm}
          autoOk={autoOk}
          name={name}
          label={label}
          required={required}
          disabled={disabled}
          helperText={errorMessage}
          error={errorStatus}
          inputProps={restInput}
          onAccept={onChange}
          format="HH:mm"
          keyboardIcon={<ClockIcon />}
          value={value === '' ? null : value}
        />
      </MuiPickersUtilsProvider>
    </div>
  )
}

TimePickerInput.defaultProps = {
  ampm: false,
  autoOk: false,
}

export default TimePickerInput
